import moment from 'moment'

import { Section } from 'components'
import { LeasingInformation } from 'containers'
import { useSelector } from 'store'
import {
  selectPublicListingLeasingInformation,
  selectPublicListingId,
  selectPublicListingPropertyDetails,
} from 'store/public-listing'

function processDateAvailable(date: string | undefined) {
  const currentDate = moment().utc()
  if (moment.utc(date).isSameOrBefore(currentDate)) {
    return 'Available Now'
  }
  return moment.utc(date).format('MMM DD, YYYY')
}

export const ListingLeasingInfoSection = () => {
  const id = useSelector(selectPublicListingId)
  const leasingInformation = useSelector(selectPublicListingLeasingInformation)
  const propertyDetails = useSelector(selectPublicListingPropertyDetails)

  const { propertyType } = propertyDetails

  const { dateAvailable, term, rentAmount, securityDeposit, termAmountOfMonths } =
    leasingInformation
  return (
    <Section title="Leasing information">
      <LeasingInformation
        rentAmount={rentAmount}
        dateAvailable={processDateAvailable(dateAvailable)}
        listingId={id}
        securityDeposit={securityDeposit}
        term={term}
        propertyType={propertyType}
        termAmountOfMonths={termAmountOfMonths}
      />
    </Section>
  )
}
